import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-33",
  "use": "icon-sheet_icon-33-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-33\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\"><path stroke-linejoin=\"round\" d=\"M7 15.5V19l-6-5.5L7 8v3.5\" /><path d=\"M13 15.5H7\" /><path stroke-linejoin=\"round\" d=\"M17 11.5V15l6-5.5L17 4v3.5\" /><path d=\"M11 7.5h6M7 11.5h10\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol